import { default as chatqfeRaWfM4ZMeta } from "/usr/src/app/pages/chat.vue?macro=true";
import { default as dashboardhKii8fXWAxMeta } from "/usr/src/app/pages/dashboard.vue?macro=true";
import { default as indexgw2ikJsyhcMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as loginRGcvZC480vMeta } from "/usr/src/app/pages/login.vue?macro=true";
import { default as logoutLM6hK8aOwEMeta } from "/usr/src/app/pages/logout.vue?macro=true";
import { default as negotiationslquizzjGkdMeta } from "/usr/src/app/pages/negotiations.vue?macro=true";
import { default as notificationsOGaQfoEYYkMeta } from "/usr/src/app/pages/notifications.vue?macro=true";
import { default as _91username_93fHWrarVCJpMeta } from "/usr/src/app/pages/profile/[username].vue?macro=true";
import { default as index77UxeWDrkFMeta } from "/usr/src/app/pages/profile/index.vue?macro=true";
import { default as published_45interestsWBZSHDX7tUMeta } from "/usr/src/app/pages/published-interests.vue?macro=true";
import { default as settingsnXXGFi4oVlMeta } from "/usr/src/app/pages/settings.vue?macro=true";
export default [
  {
    name: "chat",
    path: "/chat",
    component: () => import("/usr/src/app/pages/chat.vue").then(m => m.default || m)
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/usr/src/app/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: loginRGcvZC480vMeta || {},
    component: () => import("/usr/src/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/usr/src/app/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: "negotiations",
    path: "/negotiations",
    component: () => import("/usr/src/app/pages/negotiations.vue").then(m => m.default || m)
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/usr/src/app/pages/notifications.vue").then(m => m.default || m)
  },
  {
    name: "profile-username",
    path: "/profile/:username()",
    meta: _91username_93fHWrarVCJpMeta || {},
    component: () => import("/usr/src/app/pages/profile/[username].vue").then(m => m.default || m)
  },
  {
    name: "profile",
    path: "/profile",
    meta: index77UxeWDrkFMeta || {},
    component: () => import("/usr/src/app/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: "published-interests",
    path: "/published-interests",
    component: () => import("/usr/src/app/pages/published-interests.vue").then(m => m.default || m)
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/usr/src/app/pages/settings.vue").then(m => m.default || m)
  }
]